import { AnimatePresence, motion } from "framer-motion";
import { FC, useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import modalImage from "shared/assets/images/modal-pricing.png";
import { ReactComponent as StrmPlans } from "shared/assets/images/strm-plans.svg";
import { CloseOutlined } from "@ant-design/icons";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import { ArtistState } from "explorer/reducers/artistas";
import { MODAL_SUBSCRIPTION_RELEASE_VIEWED } from "shared/constants/StorageConsts";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";

const ModalSubscriptionRelease: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  const { showModalSubscriptionInfo } = useFlags();
  const { userArtist, loading } = useSelector(
    (state: ArtistState) => state.artists
  );
  const hasViewedModal = sessionStorage.getItem(
    MODAL_SUBSCRIPTION_RELEASE_VIEWED
  );

  const onClickClose = () => {
    sessionStorage.setItem(MODAL_SUBSCRIPTION_RELEASE_VIEWED, "true");
    setOpen(false);
  };

  useEffect(() => {
    if (
      showModalSubscriptionInfo &&
      userArtist?.distribution?.status !== DistributionStatusEnum.Signed &&
      !userArtist?.cashAdvanceSigned &&
      !hasViewedModal &&
      !loading
    ) {
      setOpen(true);
    }
  }, [showModalSubscriptionInfo, userArtist, hasViewedModal, loading]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClickClose}
          className="modal-pricing-overlay"
        >
          <motion.div
            initial={{ scale: 0, rotate: "12.5deg" }}
            animate={{ scale: 1, rotate: "0deg" }}
            exit={{ scale: 0, rotate: "0deg" }}
            onClick={(e) => e.stopPropagation()}
            className="modal-content"
          >
            <div>
              <img
                src={modalImage}
                alt="pricing"
                style={{ borderRadius: "0.5rem 0.5rem 0 0" }}
                className="responsive-pricing-image"
              />
              <div className="modal-content-image">
                <span className="flex-plan">
                  <StrmPlans />
                  {t("pages.Pricing.modal.release.title")}
                </span>
                <span className="flex-subtitle">
                  {t("pages.Pricing.modal.release.subtitle")}
                </span>
                <CloseOutlined onClick={onClickClose} className="close-icon" />
              </div>
              <div className="modal-content-text">
                <div>
                  <Trans
                    i18nKey={t("pages.Pricing.modal.release.description")}
                    components={{ span: <span className="green-color" /> }}
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalSubscriptionRelease;
